import 'css-chunksrc/client/pages/personalSpacePage/synthesis/tasks/task/taskStatus/status/list/styles.scss';export default {
  "list": "_list_zzslc_1",
  "item": "_item_zzslc_8",
  "square": "_square_zzslc_18",
  "paragraph": "_paragraph_zzslc_25"
};